import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useReducer } from 'react';
import { ExtensionContext, initialState } from './context';
import { extensionReducer, Types } from './reducer';
import { useSystemProperties } from '../../hooks';
import { checkEnabled } from '../../hooks/use-polkadot-extension';
import { useIsMountedRef } from '../../helpers/use-is-mounted-ref';
export const ExtensionProvider = ({ children, autoInitialiseExtension, extensionName, }) => {
    const isMountedRef = useIsMountedRef();
    const [state, dispatch] = useReducer(extensionReducer, initialState);
    const systemProperties = useSystemProperties();
    useEffect(() => {
        if (autoInitialiseExtension && systemProperties && !state.w3Enabled) {
            checkEnabled(extensionName, systemProperties).then(({ accounts, w3Enabled }) => {
                if (isMountedRef.current) {
                    if (w3Enabled) {
                        dispatch({
                            type: Types.ACCOUNTS_SET,
                            payload: {
                                accounts,
                            },
                        });
                    }
                    dispatch({
                        type: Types.W3_ENABLE,
                        payload: {
                            w3Enabled,
                        },
                    });
                }
            });
        }
    }, [JSON.stringify(systemProperties), isMountedRef, autoInitialiseExtension]);
    return (_jsx(ExtensionContext.Provider, { value: { state, dispatch, extensionName }, children: children }, void 0));
};
//# sourceMappingURL=provider.js.map